export {default as FaviconCommonLayout} from './components/faviconCommonLayout'
